import { render, staticRenderFns } from "./HorizontalLayout.vue?vue&type=template&id=976b7200&scoped=true&"
import script from "./HorizontalLayout.vue?vue&type=script&lang=js&"
export * from "./HorizontalLayout.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalLayout.vue?vue&type=style&index=0&id=976b7200&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976b7200",
  null
  
)

export default component.exports